import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import withAdminLayout from "../../layout/withAdminLayout";
import { Spin } from "antd";

const Dashboard = lazy(() => import("../../container/discount/Index"));
const DiscountHistory = lazy(() =>
  import("../../container/discount/DiscountHistory")
);
const CheckDiscount = lazy(() =>
  import("../../container/discount/CheckDiscount")
);
const DiscountView = lazy(() =>
  import("../../container/discount/DiscountView")
);
const ManagerDiscount = lazy(() =>
  import("../../container/discount/ManagerDiscount")
);

function DiscountRoutes() {
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="create_discount" element={<ManagerDiscount />} />
        <Route path="history" element={<DiscountHistory />} />
        <Route path="awaiting_approval" element={<Navigate to="/asm/manager/history" replace />} />
        <Route path="approved_not_used" element={<Navigate to="/asm/manager/history" replace />} />
        <Route path="approved_used" element={<Navigate to="/asm/manager/history" replace />} />
        <Route path="check_discount" element={<CheckDiscount />} />
        <Route path="discount_view/:ref" element={<DiscountView />} />
        <Route path="*" element={<Navigate to="dashboard" />} />
      </Routes>
    </Suspense>
  );
}

export default withAdminLayout(DiscountRoutes);
